import "./assets/scss/juu.scss";
import { Wrapper } from "./components/wrapper/wrapper";

const App = () => <Wrapper />;

export default App;
